import type { CryptoAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateCryptoPartInWallet } from "./partInWallet";
import { calculateCryptoYearlyYield } from "./yearlyYield";

export const calculateCryptoCurrentYield = (
  userProduct: CryptoAsset,
  currencies: {
    cashCurrency: Fiat;
    cryptoCurrency: Fiat;
  }
) => {
  const { cashCurrency, cryptoCurrency } = currencies;
  const coins = userProduct?.cryptoData || [];
  const yearlyYields = calculateCryptoYearlyYield(userProduct);
  const partsInWallet = calculateCryptoPartInWallet(
    userProduct,
    false,
    cashCurrency,
    cryptoCurrency
  );

  return coins.reduce((sum, _, index) => {
    const yearlyYield = yearlyYields?.[index] || 0;
    const partInWallet = partsInWallet?.[index] || 0;

    return sum + yearlyYield * partInWallet;
  }, 0);
};
